jQuery(document).ready(function ($) {
		

    $(".sle-sipe-link p .sle-sipe-link-item").on("click", function () {
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".sle-sipe-link p").removeClass("current");
    $(this).parent().addClass("current");
    // fadeOutできたらsrc変更してfadeIn
    $(".sle-sipe-bg img").fadeOut(500, function () {
      $(".sle-sipe-bg img")
        .attr("src", img)
        .on("load", function () {
          $(this).fadeIn(500);
        });
    });
    
    }); 
		
	$(".sle-sipe02-link p .sle-sipe02-link-item").on("click", function () {
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".sle-sipe02-link p").removeClass("current");
    $(this).parent().addClass("current");
    // fadeOutできたらsrc変更してfadeIn
    $(".sle-sipe02-bg img").fadeOut(500, function () {
      $(".sle-sipe02-bg img")
        .attr("src", img)
        .on("load", function () {
          $(this).fadeIn(500);
        });
    });
    
    });

  /*
  * Features section script 
  */
  $(".sle-sipe03-link p .sle-sipe03-link-item").on("click", function () {
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".sle-sipe03-link p").removeClass("current");
    $(this).parent().addClass("current");
    // fadeOutできたらsrc変更してfadeIn
    $(".sle-sipe03-bg img").fadeOut(500, function () {
      $(".sle-sipe03-bg img")
        .attr("src", img)
        .on("load", function () {
          $(this).fadeIn(500);
        });
    });
  });

  $("#bg-movie").YTPlayer();

  var myPlayer = $('#bg-sp-movie').YTPlayer({
    onReady: function (player) {
      let filters = {
        opacity: 100
      }
    myPlayer.YTPApplyFilters(filters)
    }
  });

  $('.js-sle-giulia-slidebox').on('init', function () {
    $('.slick-dots li:last-child').css('display', 'none');
  });

  function checkBreakPoint() {
    if ($(window).width() < 768) {
      $('.js-sle-giulia-slidebox').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true,
        variableWidth: true,
        adaptiveHeight: true,
        /*customPaging : function(slider, i) { console.log('slider2: ',$(slider)); console.log('slider:', $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav'));
          console.log('slider current: ',$(slider));
          var slidernav = $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav');
          var currentSlide = $(slider.$slides[i]);
          console.log('currentslide:', currentSlide);
          return '<a class="sle-slider-slideitem-title">'+slidernav+'</a>';
        },*/
      });
    } else {
      $('.js-sle-giulia-slidebox').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        variableWidth: true,
        adaptiveHeight: true,
        //prevArrow: '<button type="button" class="slick-prev">'+ $(this).slick('slickPrev') +'</button>',
        //nextArrow: '<button type="button" class="slick-next">'+ $(this).slickNext +'</button>',
        customPaging : function(slider, i) { console.log('slider2: ',$(slider)); console.log('slider:', $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav'));
          console.log('slider current: ',$(slider));
          var slidernav = $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav');//$(slider.$slides[i].children[0]).data('slidernav');
          var currentSlide = $(slider.$slides[i]);//.slick('slickCurrentSlide');
          console.log('currentslide:', currentSlide);
          return '<a class="sle-slider-slideitem-title">'+slidernav+'</a>';
        },
      });
    }
  }

  $('.js-sle-giulia-slidebox').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    console.log('nextSlide:', nextSlide);
  });

  /*$('.js-sle-giulia-slidebox').on('afterChange', function(event, slick, currentSlide){
    console.log('currentSlide:', currentSlide);
    switch(currentSlide) {
      case 0:
        $('.slick-dots li:first-child').css('display', 'none');
        $('.slick-dots li:last-child').css('display', 'none');
        $('.slick-dots li:nth-child(2)').removeClass('is-prev-slide');
        $('.slick-dots li:nth-child(2)').addClass('is-next-slide');
        break;
      case 2:
        $('.slick-dots li:first-child').css('display', 'none');
        $('.slick-dots li:last-child').css('display', 'none');
        $('.slick-dots li:nth-child(2)').removeClass('is-next-slide');
        $('.slick-dots li:nth-child(2)').addClass('is-prev-slide');
        break;
      default:
        $('.slick-dots li').removeAttr('style');
        $('.slick-dots li:nth-child(2)').removeClass('is-prev-slide');
        $('.slick-dots li:nth-child(2)').removeClass('is-next-slide');
    }
    /*if(currentSlide == 2) {
      $('.slick-dots li:first-child').css('display', 'none');
      $('.slick-dots li:last-child').css('display', 'none');
    } else {
      $('.slick-dots li:first-child').removeAttr('style');
      $('.slick-dots li:last-child').removeAttr('style');
    }

    if(currentSlide == 0) {
      $('.slick-dots li:first-child').css('display', 'none');
    } else {
      $('.slick-dots li:first-child').removeAttr('style');
    }*./
  });*/

  $('.js-sle-giulia-slidebox').on('swipe', function(event, slick, direction){
    console.log('direction:',direction);
    // left
  });

  /*$('.slick-dots').on('click', 'li .sle-slider-slideitem-title', function() {
    var li_no = $(this).parent('li').index();
    if ($(this).parent('li').index() > li_no) {
      get_prev_slick_img()
    }
    else {
      get_next_slick_img()
    }
  });

  setTimeout(function() {
    $('.slick-prev').prepend('<div class="prev-slick-arrow arrow-icon"><span>&#60;</span></div><div class="prev-slick-img slick-thumb-nav"></div>');
    $('.slick-next').append('<div class="next-slick-arrow arrow-icon"><span>&#62;</span></div><div class="next-slick-img slick-thumb-nav">Day 2</div>');
    get_prev_slick_img();
    get_next_slick_img();
  }, 500);*/

  /*function get_prev_slick_img() {
    // For prev img
    //var prev_slick_img = $('.slick-current').prev('.slider-image').find('img').attr('src');
    var prev_slick_img = $('.slick-current').prev('.slick-slide').find('.sle-slider-slideitem').data('slidernav');
    $('.prev-slick-img ').html(prev_slick_img);// attr('src', prev_slick_img);
    //$('.prev-slick-img').css('background-image', 'url(' + prev_slick_img + ')');
    // For next img
    var prev_next_slick_img = $('.slick-current').next('.slick-slide').find('.sle-slider-slideitem').data('slidernav');//.find('img').attr('src');
    $('.next-slick-img img').html(prev_next_slick_img); //.attr('src', prev_next_slick_img);
    //$('.next-slick-img').css('background-image', 'url(' + prev_next_slick_img + ')');
  }
  function get_next_slick_img() {
    // For next img
    var next_slick_img = $('.slick-current').next('.slick-slide').find('.sle-slider-slideitem').data('slidernav');//.next('.slider-image').find('img').attr('src');
    $('.next-slick-img').html(next_slick_img);//.attr('src', next_slick_img);
    //$('.next-slick-img').css('background-image', 'url(' + next_slick_img + ')');
    // For prev img
    var next_prev_slick_img = $('.slick-current').prev('.slick-slide').find('.sle-slider-slideitem').data('slidernav');//.prev('.slider-image').find('img').attr('src');
    $('.prev-slick-img').html(next_prev_slick_img);//.attr('src', next_prev_slick_img);
    //$('.prev-slick-img').css('background-image', 'url(' + next_prev_slick_img + ')');
  }*/

  // ウインドウがリサイズする度にチェック
  $(window).resize(function(){
    checkBreakPoint();
  });
  // 初回チェック
  checkBreakPoint();
});	
      




/*function checkBreakPoint() {
  
  if ($(window).width() < 768) {
    $('.js-sle-giulia-slidebox').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      variableWidth: true,
    });
    $('.js-sle-stelvio-slidebox').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      variableWidth: true,
    });
  }else{
    // PC向け
    $('.js-sle-giulia-slidebox.slick-initialized').slick('unslick');
    $('.js-sle-stelvio-slidebox.slick-initialized').slick('unslick');
  }
  }
  // ウインドウがリサイズする度にチェック
  $(window).resize(function(){
    checkBreakPoint();
  });
  // 初回チェック
  checkBreakPoint();*/